"use strict";

exports.publicationTypesHash = {
  articles: 'articles',
  themes: 'themes',
  news: 'news'
};
exports.publicationTypeTitlesHash = {
  articles: 'Статья',
  themes: 'Подборка',
  news: 'Новость'
};
exports.publicationTypeGenderHash = {
  articles: 'female',
  themes: 'female',
  news: 'female'
};